// extracted by mini-css-extract-plugin
export default {"wrapDropdown":"IndicatorDropdown_wrapDropdown__6zr76"};